<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import WootLabel from 'dashboard/components-next/label/Label.vue';

import { useAutomationOperationsFormatters } from './composables/useAutomationOperationsFormatters';

defineProps({
  status: { type: String, default: '' },
  generatedAt: { type: String, default: '' },
  isRefreshing: { type: Boolean, default: false },
});

defineEmits(['refresh']);

const { formatDate, formatStatus, labelColor } =
  useAutomationOperationsFormatters();
</script>

<template>
  <div
    class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between"
  >
    <div class="flex min-w-0 flex-col gap-1">
      <div class="flex items-center gap-2">
        <span class="text-heading-2 text-n-slate-12">
          {{ $t('AUTOMATION.OPERATIONS.TITLE') }}
        </span>
        <WootLabel
          :label="formatStatus(status)"
          :color="labelColor(status)"
          compact
        />
      </div>
      <span class="text-body-main text-n-slate-11">
        {{ $t('AUTOMATION.OPERATIONS.GENERATED_AT') }}
        {{ formatDate(generatedAt) }}
      </span>
    </div>
    <Button
      :label="$t('AUTOMATION.OPERATIONS.REFRESH')"
      icon="i-lucide-refresh-cw"
      color="slate"
      variant="outline"
      size="sm"
      :is-loading="isRefreshing"
      @click="$emit('refresh')"
    />
  </div>
</template>
